import * as React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Card, Radio, RadioGroup } from "@mui/material";
import idioma_lbl from "./index";

export default function Piel({ handler_data, handler_obj }) {
  return (
    <React.Fragment>
      <Grid container alignItems="center" justifyContent="center">
        <Grid item>
          <Typography variant="h6" align="center" gutterBottom>
            {idioma_lbl === "en" ? "How would you describe your skin?" :
            "¿Cómo definirías tu piel?"}
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={3} justifyContent="center">
        <Grid item>
          <RadioGroup defaultValue="" name="tipo-piel" onChange={handler_data}>
            <FormControlLabel value="seca" control={<Radio />} label={idioma_lbl === "en" ? "Dry" : "Seca"} />
            <FormControlLabel
              value="fotoenvejecida"
              control={<Radio />}
              label={idioma_lbl === "en" ? "Photoaged" : "Fotoenvejecida"}
            />
            <FormControlLabel value="grasa" control={<Radio />} label={idioma_lbl === "en" ? "Oily" : "Grasa"} />
            <FormControlLabel
              value="sensible"
              control={<Radio />}
              label={idioma_lbl === "en" ? "Sensitive" : "Sensible"}
            />
            <FormControlLabel value="mixta" control={<Radio />} label={idioma_lbl === "en" ? "Mixed" : "Mixta"} />
          </RadioGroup>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
